<template>
  <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">

    <transition name="fade">
      <Preloader v-if="showPreloader || IS_AUTHENTICATING" :loading_text="loading_text"/>
    </transition>

      <router-view @signInError="signInError"/>
      <v-alert :type="alert_type" elevation="2" class="alert-notif" v-model="alert" transition="scale-transition" dismissible>
        {{ message }}
      </v-alert>
  </v-app>

</template>

<script>
import { EventBus } from '@/event_bus';
import Preloader from './views/ched_dashboards/sub-components/preloader/Preloader.vue';

export default {
  name: 'App',

  components: {
    Preloader
  },

  data() {
    return {
      alert_type: 'info',
      alert: false,
      message: '',
      loading_text: 'CHED RO XI - Scholarship System is now loading...',
      signingIn: false,
    }
  },

  computed: {
    showPreloader() {
      return this.$store.getters.GET_PRELOADER_STATE;
    },
    IS_AUTHENTICATING(){
      return this.$store.getters.IS_AUTHENTICATING;
    }
  },

  methods: {
    signInError(message, alert_type, state) {
        this.message = message;
        this.alert = state;
        this.alert_type = alert_type;

        setTimeout(() => {
          this.alert = !this.alert;
        }, 9000);
    },

    enableCustomEventListener(){
      EventBus.$on('showAlertDialog', (message, alert_type, state) => {
        this.message = message;
        this.alert = state;
        this.alert_type = alert_type;

        setTimeout(() => {
          this.alert = !this.alert;
        }, 5000);
      });
    }
  },

  created () {
    this.enableCustomEventListener();
  },
};
</script>

<style>
.alert-notif{
  position: fixed !important;
  bottom: 0 !important;
  left: 10px !important;
  z-index: 2000 !important;
}
</style>
